<template>
  <div>
    <div class="d-flex detail_top align-items-center">
      <img :src="diary.headUrl" class="border-p50 headImg"/>
      <div class="mar-left10">{{diary.nickname}}</div>
    </div>

    <div class="diaryImgBox d-flex align-content-center justify-content-center">
      <img :src="showImg" class="diaryImg"/>
    </div>

    <div style="overflow-x: scroll" class="d-flex listImgBoxPad">
      <div v-for="(item,index) in diary.diaryImgs"  >
        <img :src="item.ip+item.url" class="listImg" :class="showImgIndex==index?'selectImgStyle':'border2'" v-on:click="selectImg(index)"/>
      </div>
    </div>

    <div class="d-flex justify-content-center">
      {{diary.secondTitle}}
    </div>

    <div class="d-flex align-items-center justify-content-center" style="margin-top:30px">
      <img :src="diary.circleImg" class="circleImg imgFit"/>
      <div class="circle-margin">
        <div class="font20">{{diary.circleTile}}</div>
        <div class="font16" style="margin-top:15px">{{diary.clockNum}}人打卡{{diary.joinNum}}人参与</div>
      </div>
      <div class="joinBtn" v-on:click="lookMore(layerShow)">点击参与</div>
    </div>

    <div class="d-flex align-items-center justify-content-center" style="margin-top:15px" v-on:click="lookMore(layerShow)">
       发布于&nbsp;{{diary.releaseDate}}
       <img src="../../assets/img/index/like.png" class="iconImg" style="margin-left:15px;margin-right:10px"/>
       {{diary.likeNum}}赞
       <img src="../../assets/img/index/comment2.png" class="iconImg" style="margin-left:15px;margin-right:10px"/>
       {{diary.commentNum}}评论
    </div>

    <!-- 评论模块 -->
    <div class="font-weight-bold" style="margin-top:30px;margin-left:150px;font-size:30px">评论</div>
    <div class="d-flex align-items-center " v-for="item in diary.commentList" style="margin-top:15px;margin-left:120px;">
      <img :src="item.userHeadUrl" style="width:100px;height:100px;border-radius: 50%;border:1px solid #c1c1c1"/>
      <div style="margin:0 100px 0 25px">
        <div>{{item.userNickName}}</div>
        <div>{{item.commentDate}}</div>
        <div>{{item.comment}}</div>
      </div>

      <div class="d-flex align-items-center" v-on:click="lookMore(layerShow)" >
         <img src="../../assets/img/index/comment1.png" class="iconImg" />
         <span style="margin-left:15px">回复</span>
      </div>
    </div>
    <div v-if="diary.commentList == undefined ||diary.commentList.length <=0" class="d-flex justify-content-center" style="margin-top:50px">
      暂无评论
    </div>

    <!-- 推荐模块 -->
    <div style="padding-bottom:50px">
      <div style="font-size: 32px;font-weight: bolder;margin:40px 0 30px 25px">推荐</div>
      <div class=" pad10" style="column-count: 2;column-gap: 0;">
        <div class="diaryBox" v-for="item in list" style="height:100%;overflow:auto;">
          <div class="imgBox" v-on:click="toDetail(item.id)">
            <img :src="item.src" class="imgFit"/>
          </div>
         <div class="sepLine"></div>
          <div class="twoLine intro">{{item.text}}</div>
          <div class="d-flex align-items-center justify-content-between bottomBox" style="margin-top:10px">
            <div class="nickDiv d-flex align-items-center">
              <img  :src="item.headUrl" />
              <p>{{item.nickname}}</p>
            </div>
            <div class="lookDiv d-flex align-items-center">
              <img src="https://image.xingqubaike.com:8443/minicard/interest/eye.png" />
              <p>{{item.lookNum}}</p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="list==undefined||list.length==0" class="d-flex justify-content-center">
        暂无推荐内容
      </div>
    </div>

    <!-- 弹窗模块 -->
    <div class="layer d-flex flex-column align-items-center justify-content-center" v-if="layerShow">
      <div class="miniProjectImgBox d-flex flex-column justify-content-center align-items-center bgc-ffffff">
        <img src='../../assets/img/index/miniProjectImg.jpg' class="miniProjectImg"/>
        <div>微信扫码，查看更多精彩</div>
      </div>

      <img src='../../assets/img/index/close.png' class="closeImg" v-on:click="lookMore(layerShow)"/>
    </div>




  </div>
</template>

<script>
 import axios from "axios";
 export default {
   name: 'detail',
   data () {
     return {
       diary: {},//日记详情
       layerShow:false,//弹窗是否显示
       list: [],//推荐数组
       showImg:'',//顶部展示图
       showImgIndex:0,//图片默认选中小标为0
     }
   },
   mounted(){//页面加载时调用方法
    var diaryId = this.$route.params.id;//从列表页接受路径中的参数值
    this.getData(diaryId);
   },
   methods:{
     lookMore:function(param){//弹出弹窗
       this.layerShow=!param

     },

     //获取详情数据
     getData:function(diaryId){
       var data = {diaryid:diaryId};
       axios.post('https://www.xingqubaike.com/wx/handshake-provider-xswl-home/home/official/getDiaryDetailForH5',data).then(response => {
           this.list=response.data.result.json.list;
           this.diary = response.data.result.json.entity;
           this.showImg = response.data.result.json.entity.diaryImgs[0].ip+response.data.result.json.entity.diaryImgs[0].url;
       }, response => {
           console.log("error");
       });
     },

    //点击推荐中的日记，跳转到详情
     toDetail:function(id){
       this.$router.push({ name: 'detail',params:{id:id}})
       this.getData(id)
     },

     //点击图片显示当前图片
     selectImg:function(index){
        this.showImg = this.diary.diaryImgs[index].ip+this.diary.diaryImgs[index].url;
        this.showImgIndex=index;
     }


   },
 }
</script>

<style>
  .detail_top{margin-top:30px;margin-left:20px;}
  .border-p50{border-radius:50%}
  .headImg{width:80px;height:80rpx}
  .mar-left10{margin-left:10px}
  /* .diaryImgBox{width:680px;height:250px;border:1px solid black} */
  .diaryImg{width:700px;height:250px;border:1px solid red;object-fit: cover;margin-top:30px}
  .listImg{width:180px;height:130px;object-fit: cover;margin-right:20px}
  .listImgBoxPad{padding:20px 0 20px 20px}
  .circleImg{width:100px;height:100px}
  .font20{font-size:20px}
  .font16{font-size:16px;}
  .circle-margin{margin:0 15px 0 20px}
  .selectImgStyle{border:3px solid red}
  .joinBtn{width:150px;height:60px;border-radius: 5px;background:#f99a3e;color:#f1f1f1;text-align: center;line-height: 60px;}
  .iconImg{width:30px;height:30px}

  .pad10{
    padding:10px
  }

  .title{
     font-size:30px;
     font-weight:bolder;
     color:#333333;
     margin:20px 0 0 20px
  }

  .diaryBox{
    width:355px;
    border:1px solid #d1d1d1;
    border-radius:10px;
    padding-bottom:10px;
    margin-bottom:10px;
  }

  .imgBox{
    width:355px;
    height:355px;
    border-radius:10px 10px 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }

  .imgBox>img{
    width:355px;
    height:355px;
    border-radius:10px 10px 0 0;
  }


  .intro{
    padding:0 10px;
    font-size:20px;
    margin-top:10px
  }

  .lookDiv img{
    width:32px;
    height:32px
  }

  .nickDiv img{
    width:50px;
    height:50px;
    border-radius:50%
  }

  .nickDiv p,.lookDiv p{margin-left:5px;font-size:16px}

  .bottomBox{
    padding:0 10px;
  }

  .sepLine{
    width:355px;
    height:10px;
    background:#f1f1f1;
  }

  .lookMore{
    padding:30px 0 50px 0
  }

  .layer{
    width:100%;
    height:100%;
    background:rgba(0,0,0,0.5);
    position: fixed;
    top:0;
    left:0;
    z-index: 10;
  }

  .miniProjectImgBox{
    width:400px;
    height:400px;
    border-radius: 10px;
  }

  .miniProjectImgBox div{
    margin-top:10px
  }

  .miniProjectImg{
    width:300px;
    height:300px;
  }

  .closeImg{
    width:80px;
    height:80px;
    margin-top:25px
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/detail.vue